// extracted by mini-css-extract-plugin
export default {"walletBtn":"wallet_walletBtn__xjJf8"};